import { z } from 'zod';
import { DecimalLikeSchema, IsoDateTimeSchema, PaginationSchema, UuidSchema } from './common.js';
export const PagoSchema = z.object({
    id: UuidSchema,
    guardiaId: UuidSchema,
    monto: DecimalLikeSchema,
    metodoPago: z.string().max(100).nullable(),
    tipo: z.string().max(100).nullable(),
    notas: z.string().max(1000).nullable(),
    cajaId: UuidSchema.nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
export const CreatePagoRequestSchema = z.object({
    guardiaId: UuidSchema,
    monto: DecimalLikeSchema,
    metodoPago: z.string().max(100).nullable().optional(),
    tipo: z.string().max(100).nullable().optional(),
    notas: z.string().max(1000).nullable().optional(),
    cajaId: UuidSchema.nullable().optional(),
});
export const UpdatePagoRequestSchema = z.object({
    monto: DecimalLikeSchema.optional(),
    metodoPago: z.string().max(100).nullable().optional(),
    tipo: z.string().max(100).nullable().optional(),
    notas: z.string().max(1000).nullable().optional(),
    cajaId: UuidSchema.nullable().optional(),
});
export const PagoListQuerySchema = PaginationSchema.extend({
    guardiaId: UuidSchema.optional(),
    from: IsoDateTimeSchema.optional(),
    to: IsoDateTimeSchema.optional(),
});
export const AdelantoSchema = z.object({
    id: UuidSchema,
    guardiaId: UuidSchema,
    monto: DecimalLikeSchema,
    fecha: IsoDateTimeSchema,
    descripcion: z.string().max(1000).nullable(),
    createdAt: IsoDateTimeSchema.nullable(),
});
export const CreateAdelantoRequestSchema = z.object({
    guardiaId: UuidSchema,
    monto: DecimalLikeSchema,
    fecha: IsoDateTimeSchema.optional(),
    descripcion: z.string().max(1000).nullable().optional(),
});
export const UpdateAdelantoRequestSchema = z.object({
    monto: DecimalLikeSchema.optional(),
    fecha: IsoDateTimeSchema.optional(),
    descripcion: z.string().max(1000).nullable().optional(),
});
export const AdelantoListQuerySchema = PaginationSchema.extend({
    guardiaId: UuidSchema.optional(),
    from: IsoDateTimeSchema.optional(),
    to: IsoDateTimeSchema.optional(),
});
export const SaldoGuardiaSchema = z.object({
    guardiaId: UuidSchema,
    totalCalculado: DecimalLikeSchema,
    totalPagado: DecimalLikeSchema,
    totalAdelantos: DecimalLikeSchema,
    saldoPendiente: DecimalLikeSchema,
});
//# sourceMappingURL=pagos.js.map